export default {
  space: '2qgj2z5v5bl2',
  accessToken: '84BoNFkpWbELcaaxTtN8MBdHoBi7dzs6cvl4ICaxCqk'
}